module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_rogaland_neg.4e30e6b0.svg";